/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terminology_LookupInputs */



/**
* | output |
* | --- |
* | "KNP Terminology Lookup" |
*
* @param {Knp_Terminology_LookupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terminology_lookup = /** @type {((inputs?: Knp_Terminology_LookupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terminology_LookupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Recherche terminologique KNP")
	if (locale === "de") return /** @type {LocalizedString} */ ("KNP-Terminologie-Nachschlagewerk")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricerca terminologica KNP")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск терминов KNP")
	if (locale === "es") return /** @type {LocalizedString} */ ("Búsqueda de terminología de KNP")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP术语查询")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP用語検索")
	if (locale === "hi") return /** @type {LocalizedString} */ ("केएनपी शब्दावली खोज")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Consulta de terminologia KNP")
	return /** @type {LocalizedString} */ ("KNP Terminology Lookup")
});